<template>
    <div>
        <v-card class="p-3 flex-fill h-100 w-100">
            <div class="d-flex justify-content-between">
                <h5 v-if="account.tis_type.code !== 'DAHUB_QUEBEC'">Contact</h5>
                <h5 v-else>Destinataire Uska</h5>

                <div class="d-flex justify-content-between gap-10" v-if="!loading">
                    <v-btn outlined class="custom-button-primary"
                           style="height: 36px;min-width: 42px;padding: 0"
                           @click="openModal(contact)"
                           v-if="!providerSelectionsCount && contact !== null"
                    >
                        <v-icon>edit</v-icon>
                    </v-btn>

                    <v-btn outlined class="custom-button-primary"
                           style="height: 36px;min-width: 42px;padding: 0"
                           @click="prepareUpdateContact(provider)"
                           v-else-if="!providerSelectionsCount && contact === null"
                    >
                        <v-icon>edit</v-icon>
                    </v-btn>

                    <v-tooltip right v-else-if="providerSelectionsCount">
                        <template v-slot:activator="{ on }">
                            <v-btn outlined
                                   color="grey"
                                   disabled
                                   style="height: 36px;min-width: 42px;padding: 0; pointer-events: auto"
                                   v-on="on"
                            >
                                <v-icon v-on="on">edit</v-icon>
                            </v-btn>
                        </template>
                        <div>
                            Les coordonnées du contact ne sont pas modifiables, car ce dernier est lié à une
                            sélection.<br>
                            Il sera modifié si vous éditez le contact sur Apidae. Le contact sur Uska sera mis à jour
                            au moyen du
                            temps réel Apidae.
                        </div>
                    </v-tooltip>
                </div>
            </div>

            <v-skeleton-loader v-if="loading" type="paragraph" class="mt-4"></v-skeleton-loader>
            <div v-else>
                <div>
                    <div class="mb-2" v-if="contact && contact.first_name !== null && contact.first_name !== undefined">
                        <v-icon class="text-primary" left>person</v-icon>
                        <span class="mt-auto mb-auto">{{ contact.first_name }} {{ contact.last_name }}</span>
                    </div>
                    <div class="mb-2" v-if="contact && contact.email !== null && contact.email !== undefined">
                        <v-icon class="text-primary" left>email</v-icon>
                        <span class="mt-auto mb-auto">{{ contact.email }}</span>
                    </div>
                    <div class="mb-2" v-if="contact && contact.phone !== null && contact.phone !== undefined">
                        <v-icon class="text-primary" left>phone</v-icon>
                        <span class="mt-auto mb-auto">{{ contact.phone }}</span>
                    </div>
                </div>

                <div class="mb-2"
                     v-if="contact && contact.profession !== null && contact.profession !== undefined">
                    <v-icon class="text-primary" left>work</v-icon>
                    <span class="mt-auto mb-auto">{{ contact.profession.label }}</span>
                </div>

                <div class="mb-2"
                     v-if="contact && contact.token">
                    <v-icon class="text-primary" left>web</v-icon>
                    <v-tooltip right v-if="provider && provider.pro_connexion && provider.pro_connexion.premium">
                        <template v-slot:activator="{ on }">
                            <span class="mt-auto mb-auto" v-on="on">
                        Espace pro
                    </span>
                        </template>
                        <div>
                            Compte payant, non accessible sans authentification
                        </div>
                    </v-tooltip>
                    <span v-else-if="espaceProUrl">
                        <a :href="espaceProUrl" target="_blank">
                            <span class="mt-auto mb-auto">Espace pro</span>
                        </a>
                        <v-tooltip right>
                            <template v-slot:activator="{ on }">
                                <v-btn icon
                                       x-small
                                       class="ml-2"
                                       v-on="on"
                                       @click="copyEspaceProUrl">
                                    <v-icon small>{{ copied ? "check" : "content_copy" }}</v-icon>
                                </v-btn>
                            </template>
                            <div>{{ copied ? "Lien copié !" : "Copier le lien" }}</div>
                        </v-tooltip>
                    </span>
                    <v-tooltip right v-else>
                        <template v-slot:activator="{ on }">
                            <span class="mt-auto mb-auto" v-on="on">
                        Espace pro
                    </span>
                        </template>
                        <div>
                            Ce prestataire n’a pas encore d’espace pro. Contactez-le via une campagne ou une demande
                            individuelle pour lui en créer un.
                        </div>
                    </v-tooltip>
                </div>
            </div>
        </v-card>

        <update-receiver-modale :edit-contact-modal="editContactModal" :selected-contact="selectedContact"
                                :selected-provider="selectedProvider">
        </update-receiver-modale>

        <v-dialog v-model="editModal" persistent max-width="900px" v-if="editModal && currentContact">
            <v-card>
                <v-card-title class="d-flex justify-content-between">
                    <div>
                        <span class="headline">Edition du contact</span>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field outlined label="Prénom" hide-details
                                          v-model="currentContact.first_name">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field outlined label="Nom" hide-details
                                          v-model="currentContact.last_name">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field outlined label="E-mail*" required
                                          :disabled="providerSelectionsCount > 0"
                                          hide-details v-model="currentContact.email">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6">
                            <v-text-field outlined label="Téléphone" hide-details
                                          v-model="currentContact.phone">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-select :items="professions"
                                      outlined
                                      label=" Fonction"
                                      hide-details
                                      v-model="currentContact.profession"
                                      item-text="label"
                                      return-object>
                            </v-select>
                        </v-col>
                    </v-row>
                    <div class="d-flex justify-content-end gap-10">
                        <v-btn @click="editModal = false">Annuler</v-btn>
                        <v-btn class="default-button custom-button-primary" @click="updateContact">
                            Modifier le contact
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "ContactBloc",
    components: {
        UpdateReceiverModale: () => import(/* webpackChunkName: "update-receiver-modale" */ "../UpdateReceiverModale"),
    },
    props: ["contact", "providerId", "providerSelectionsCount", "provider", "loading"],
    data() {
        return {
            editModal: false,
            professions: [],
            currentContact: {
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                profession: null,
            },
            phoneEdit: false,
            editContactModal: false,
            selectedContact: null,
            selectedProvider: [],
            espaceProUrl: null,
            copied: false,
            copiedTimeout: null,
        }
    },
    methods: {
        openModal(contact) {
            if (!this.professions.length) {
                this.getProfessions()
            }
            if (this.contact !== null) {
                this.currentContact = JSON.parse(JSON.stringify(contact))
            }
            this.editModal = true
        },
        getProfessions() {
            this.$http.get("resource/professions").then(res => {
                this.professions = res.body.data.professions
            })
        },
        updateContact() {
            let payload = {
                contact: this.currentContact,
                providerId: this.providerId,
            }

            this.$http.post("professional/contact", payload).then(res => {
                this.$store.dispatch("pro/fetchContact", this.contact ? this.contact.token : res.body.token)

                if (res.body.success) {
                    this.editModal = false

                    this.$global.$emit("reload-summary")
                }
            })
        },
        prepareUpdateContact(provider) {
            this.editContactModal = true
            this.selectedContact = provider.email
            this.selectedProvider = provider
        },
        generateUskaLink() {
            if (!this.contact) return
            if (process.env.NODE_ENV !== "development") {
                if (this.contact.uska_magic_link) {
                    this.espaceProUrl = process.env.VUE_APP_USKA_FRONT_URL + "mes-echanges?token=" + this.contact.uska_magic_link + "&source=" + btoa(this.account.id)
                }
            } else if (this.contact.token) {
                this.espaceProUrl = "/espace-pro/" + this.contact.token + "/solicitations" + "?no_redirection=true"
            }
        },
        async copyEspaceProUrl() {
            try {
                await navigator.clipboard.writeText(this.espaceProUrl);
                this.copied = true;
                clearTimeout(this.copiedTimeout);
                this.copiedTimeout = setTimeout(() => {
                    this.copied = false;
                }, 2000);
            } catch (e) {
                console.error('Impossible de copier le lien', e);
            }
        },
    },
    computed: {
        ...mapState("account", ["account", "vtContract"]),
    },
    watch: {
        contact: {
            handler() {
                this.generateUskaLink()
            },
            deep: true,
            immediate: true,
        },
    },
    beforeDestroy() {
        clearTimeout(this.copiedTimeout);
    },
    created() {
        this.$global.$on("close-update-modal", () => {
            this.editContactModal = false
        })
    },
}
</script>